import { FormInput } from "../../../components/ui-lib/form/FormInput";
import Label from "../../../components/ui-lib/Label";
import { useWatch } from "react-hook-form";
import { FormWizardStepProps } from "../../../models/form-wizard-step-props";
import { validateEndDate, validateStartDate } from "./validate-functions";
import { VacancyFormFields } from "../VacancyCreateWizard";
import { useMemo } from "react";

function DurationStep({
  control,
  register,
  errors,
  canEditStartDate = true,
}: FormWizardStepProps<VacancyFormFields> & { canEditStartDate?: boolean }) {
  const dateStrings = useWatch({ name: ["start", "end"], control });
  const dates = useMemo(
    () => dateStrings.map((date) => new Date(date)),
    [dateStrings],
  );

  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="space-y-4">
        <h2
          className="text-center text-th-primary-900"
          data-cy="wizard-step-title"
        >
          Dauer des Ausfalls
        </h2>
        <Label
          text="Von"
          position="top"
          labelClass="uppercase font-bold text-th-primary-900"
        >
          <FormInput
            name="start"
            label="Von"
            id="start"
            register={register}
            type="date"
            disabled={!canEditStartDate}
            rules={{
              required: "Sie müssen ein Datum selektieren.",
              validate: (value: Date) => validateStartDate(value, dates[1]),
            }}
            errors={errors as any}
          ></FormInput>
        </Label>

        <Label
          text="Bis"
          position="top"
          labelClass="uppercase font-bold text-th-primary-900"
        >
          <FormInput
            label="Bis"
            id="end"
            name="end"
            register={register}
            type="date"
            rules={{
              required: "Sie müssen ein Datum selektieren.",
              validate: (value: Date) => validateEndDate(value, dates[0]),
            }}
            errors={errors as any}
          ></FormInput>
        </Label>
      </div>
    </div>
  );
}

export default DurationStep;
